module.exports = __webpack_public_path__ + "hoop_visita_02_01.png";